import Component from '../core/Component'
import EventBus from '../core/EventBus'
import { substitute } from '../utils/String'

export default class ProductAvailabilityForm extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            select: null,
            gtm: null
        }

        this.lastValue = null
        this.value = null
    }

    prepare() {
        EventBus.on('sizes:select:change', this.handleSizesSelectChange)
        EventBus.on('modal:open', this.handleModalOpen)
        this.track()
    }

    destroy() {
        EventBus.off('sizes:select:change', this.handleSizesSelectChange)
        EventBus.off('modal:open', this.handleModalOpen)
    }

    handleModalOpen = ({ id }) => {
        if (id !== 'product-availability') {
            return
        }

        this.triggerChangeIfNewValue()
        this.track()
    }

    handleSizesSelectChange = ({ value }) => {
        if (!this.ref.select) {
            return
        }

        this.element.offsetWidth

        this.value = value
    }

    triggerChangeIfNewValue() {
        if (this.lastValue === this.value) {
            return
        }
        this.ref.select.value = this.value
        if ('createEvent' in document) {
            const event = document.createEvent('HTMLEvents')
            event.initEvent('change', true, true)
            this.ref.select.dispatchEvent(event)
        } else {
            this.ref.select.fireEvent('onchange')
        }
        this.lastValue = this.value

        this.track()
    }

    track() {
        return;

        // const isOpen = Component.getFromElement('product-availability')?.isOpen()
        // if (!isOpen) {
        //     return
        // }

        // if (this.ref.select && !this.ref.select.value) {
        //     return
        // }

        // let option = ''
        // const gtm = this.ref.gtm?.textContent?.trim() || ''

        // if (this.ref.select) {
        //     if (this.ref.select.dataset.name) {
        //         option = this.ref.select.dataset.name
        //     } else {
        //         option = this.ref.select.options[this.ref.select.selectedIndex].textContent
        //     }
        // }

        // const data = JSON.parse(substitute(gtm, {
        //     variant: option
        // }))

        // dataLayer.push(data)
    }
}
